import { configureCrypto, setCryptoConfig } from "core/model/crypto/singleton";
import { configureLogging, LoggingType } from "core/model/logging";
import { configureRealUserMonitoring } from "core/model/real-user-monitoring";
import { AppType } from "core/types";
import React, { useEffect } from "react";
import { Persistor } from "redux-persist";
import { AppStore, persistor, store } from "reduxentities/store";
import PandaProvider, { configurePanda } from "./PandaProvider";

export type ServiceFactoryAppString =
  | "ACP"
  | "Careprovider"
  | "Clinic"
  | "ProviderSearch";

export type Services = {
  logger: LoggingType;
  persistor: Persistor;
  store: AppStore;
};

export function ServicesProvider({
  app,
  children,
}: {
  app: AppType;
  children: React.ReactNode;
}) {
  const pandaSpecs = configurePanda(app);

  useEffect(() => {
    const crypto = configureCrypto();

    setCryptoConfig(crypto);
  }, []);

  return <PandaProvider specs={pandaSpecs}>{children}</PandaProvider>;
}

export default (app: ServiceFactoryAppString): Services => {
  configureRealUserMonitoring(app);

  const logger = configureLogging(app);

  return {
    logger,
    persistor,
    store,
  };
};
